<template>
    <div class="content-subscribe-container">
      <search @search-subscribe-click="searchSubscribeClick"
      @search-click="searchClick"
      ></search>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="result-container">
            <div v-if="!search" class="tips">请输入对应帐号名称或者准确账号名&帐号ID,进行搜索</div>
            <div v-if="search && resultListEmpty" class="tips">暂无搜索结果</div>
            <div v-else="">
              <list :account-list="accountList" @subscribr-click="subscribeClick"
              @cancel-subscribe-click="cancelSubscribeClick"></list>
            </div>
          </div>
        </article>
      </div>
      <edit-modal ref="editModalRef" :name="name"
      @subscribe-modal-ok-event="subscribeModalOkEvent"
      ></edit-modal>
    </div>
</template>
<script type="text/babel">
  import search from './search.vue';
  import list from './list.vue';
  import editModal from './editModal.vue'

  export default{
    components:{
      search,list,editModal
    },
    data(){
      return{
        search:false,
        page:1,
        name:"",
        type:0,//订阅类型,10微博,11Ins,12微信
        accountList:[],
        resultListEmpty:false,
        subscribeIndex:0,//订阅选中index
        subscribeType:1,//订阅类型,1搜索订阅,2直接订阅
        searchName:"",//搜索name
        subscribeModal:{
          accountName:"",
          accountKey:"",
          accountId:0,
          keywords:[],
          excludeKeywords:[]
        }
      }
    },
    mounted(){
      this.name = this.$route.query.name;
      this.type = this.$route.query.type;
    },
    methods:{

      /**
       * 取消订阅点击
       * */
      cancelSubscribeClick(obj,index){
        this.subscribeIndex = index;
        this.cancelSubscribeModalSave()
      },
      /**
       * 搜索帐号点击
       * */
      searchClick(accountName){
        if(!accountName){
          this.$message("请输入要搜索的帐号~")
          return
        }
        this.searchName = accountName;
        this.getAccountList();
      },
      /**
       * 订阅点击
       * */
      subscribeClick(obj,index){
        this.subscribeIndex = index;
        this.subscribeModal.accountKey = this.accountList[this.subscribeIndex].accountKey;
        this.subscribeType = 1;
        this.subscribeModalShow();
      },
      /**
       * 订阅弹窗确认点击
       * */
      subscribeModalOkEvent(keywords,excludeKeywords){
        if(this.subscribeType != 2){//搜索后,从列表里订阅
          this.subscribeModal.accountName = this.accountList[this.subscribeIndex].accountName;
          this.subscribeModal.accountKey = this.accountList[this.subscribeIndex].accountKey;
        }
        this.subscribeModal.keywords = keywords;
        this.subscribeModal.excludeKeywords = excludeKeywords;
        this.subscribeModalSave();
      },
       /**
       *  搜索订阅帐号(直接订阅)
       * */
      searchSubscribeClick(accountName,key){
        this.subscribeModal.accountName = accountName;
        this.subscribeModal.accountKey = key;
        this.subscribeType = 2;
        if(this.type == 11){
          if(!this.subscribeModal.accountKey){
            this.$message("请用户ID~")
            return
          }
        }else{
          if(!this.subscribeModal.accountName || !this.subscribeModal.accountKey){
            this.$message("用户名和用户ID都要填写~")
            return
          }
        }
        this.subscribeModalShow();
      },
      /**
       * 获取搜索列表
       * */
      getAccountList(name){
        this.search = true;
        this.resultListEmpty = false;
        HttpRequest.get("/admin.php?method=fashion.searchAccount",{page:this.page,type:this.type,accountName:this.searchName},true).then((response)=>{
          _.each(response.data.list,(item,index)=>{
            item.status = false;
            item.acccountId = 0;
          });
          this.accountList = response.data.list;
          if(this.page == 1 && !this.accountList.length){
            this.resultListEmpty = true;
          }
        }, (response) => {
          this.$message("搜索接口失效，可以直接使用【帐号ID】和【帐号名称】的组合订阅");
        });

      },
      /**
       * 订阅弹窗展示
       * */
      subscribeModalShow(){
        this.$refs.editModalRef && this.$refs.editModalRef.showModal()
      },
      /**
       * 订阅保存
       * */
      subscribeModalSave(){
        let params = {
          type:this.type,
          accountName:(this.type == 11) ? this.subscribeModal.accountKey : this.subscribeModal.accountName,
          accountId:this.subscribeModal.accountId,
          accountKey:this.subscribeModal.accountKey,
          keywords:this.subscribeModal.keywords,
          excludeKeywords:this.subscribeModal.excludeKeywords
        }
        HttpRequest.post("/admin.php?method=fashion.doSaveSource",params).then((response)=>{
          if(response.data.success){
            this.$message("订阅成功")
            //成功后修改状态
            if(this.subscribeType == 1){
              //搜索订阅后获取Id,并保存
              this.accountList[this.subscribeIndex].status = true;
              this.accountList[this.subscribeIndex].accountId = response.data.result.accountId;
              console.log(this.accountList[this.subscribeIndex],response.data.result.accountId)
            }else{
              setTimeout(()=>{
                this.$router.push({
                  name: 'setSource',
                  query: {
                    type: this.type
                  }
                })
              },2000)
            }
          }
        });
      },
      /**
       * 取消订阅保存
       * */
      cancelSubscribeModalSave(){
        if(confirm("确定要取消订阅吗")){
          let params = {
            accountId:this.accountList[this.subscribeIndex].accountId,
            status:0
          }
          HttpRequest.post("/admin.php?method=fashion.setSourceStatus",params).then((response)=>{
            if(response.data.success){
              //取消订阅成功
              this.$message("已取消订阅")
              this.accountList[this.subscribeIndex].status = false;
            }
          })
        }
      }
    }
  }
</script>
<style lang="less">
  .content-subscribe-container{
    .result-container{
      margin: 40px 0;
    }
    .tips{
      min-height: 400px;
      text-align: center;
    }
  }
</style>
